import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ClinicMedicalServiceFormGroupMapping {
  id?: number;
  serviceID: number;
  groupName: string;
  branchID: number;
  requireForEachService: boolean;
  isActive: boolean;
  createdBy?: number;
  createdDT?: Date;
  updatedBy?: number;
  updatedDT?: Date;
}

export interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ClinicMedicalServiceFormGroupService {
  private apiUrl = `${environment.API_URL}ClinicMedicalServiceFormGroup`;

  constructor(private http: HttpClient) { }

  /**
   * Save (insert or update) medical service form group mapping
   */
  saveFormGroupMapping(model: ClinicMedicalServiceFormGroupMapping): Observable<ApiResponse<number>> {
    const url = `${this.apiUrl}/SaveFormGroupMapping`;
    return this.http.post<ApiResponse<number>>(url, model);
  }

  /**
   * Get form group mapping by medical service ID
   */
  getFormGroupByService(serviceId: number): Observable<ApiResponse<ClinicMedicalServiceFormGroupMapping>> {
    const url = `${this.apiUrl}/GetFormGroupByService`;
    const formData = new FormData();
    formData.append('serviceId', serviceId.toString());
    return this.http.post<ApiResponse<ClinicMedicalServiceFormGroupMapping>>(url, formData);
  }

  /**
   * Get all mappings for a branch
   */
  getAllMappingsByBranch(branchId: number): Observable<ClinicMedicalServiceFormGroupMapping[]> {
    const url = `${this.apiUrl}/GetAllMappingsByBranch`;
    const formData = new FormData();
    formData.append('branchId', branchId.toString());
    return this.http.post<ClinicMedicalServiceFormGroupMapping[]>(url, formData);
  }

  /**
   * Check if medical service has form group assigned
   */
  hasFormGroup(serviceId: number): Observable<{ success: boolean; hasFormGroup: boolean }> {
    const url = `${this.apiUrl}/HasFormGroup`;
    const formData = new FormData();
    formData.append('serviceId', serviceId.toString());
    return this.http.post<{ success: boolean; hasFormGroup: boolean }>(url, formData);
  }

  /**
   * Get all form types for a specific medical service
   */
  getFormsForService(serviceId: number, branchId: number): Observable<ApiResponse<any[]>> {
    const url = `${this.apiUrl}/GetFormsForService`;
    const formData = new FormData();
    formData.append('serviceId', serviceId.toString());
    formData.append('branchId', branchId.toString());
    return this.http.post<ApiResponse<any[]>>(url, formData);
  }

  /**
   * Remove form group mapping from medical service
   */
  removeFormGroupMapping(serviceId: number): Observable<ApiResponse<number>> {
    const url = `${this.apiUrl}/RemoveFormGroupMapping`;
    const formData = new FormData();
    formData.append('serviceId', serviceId.toString());
    return this.http.post<ApiResponse<number>>(url, formData);
  }
}
